<template>
 <d-row>
      <d-col lg="12">
  <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
    <i class="fa fa-info mx-2"></i>
    <span id="warning">{{ error_msg }}</span> 
  </d-alert>

  <d-card class="card-small mb-4">
    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#FF6700"/>
    <!-- Card Header -->
    <d-card-header class="border-bottom">
       <d-button type="button" :disabled="loading" class="btn-accent" @click="save_form" data-toggle="tooltip" data-placement="top" title="Save Form" ><i class="material-icons">save_alt</i> Simpan</d-button>&nbsp;
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form>
              <d-form-row>
                <!-- Full Name -->
                <d-col md="6" :class="{ 'form-group--error' : $v.fullname.$error }">
                  <label for="feFullName">Nama Lengkap</label>
                  <d-form-input type="text" id="name" placeholder="Nama Lengkap" v-model.trim="$v.fullname.$model" />
                  <div  class="verror" v-if="!loading && !$v.fullname.required">Harap isi kolom ini</div>
                </d-col>

                <!-- gender -->
                <d-col md="6" :class="{ 'form-group--error' : $v.gender.$error }">
                  <label for="feFullName">Gender</label>
                  <d-form-select v-model="gender" :options="genders" style="padding-left:1px" />
                  <div  class="verror" v-if="!loading && !$v.gender.required">Harap isi kolom ini</div>
                </d-col>

                <!-- dob -->
                <d-col md="6" :class="{ 'form-group--error' : $v.dob.$error }">
                  <d-row>
                    <d-col md=6>
                      <label for="feFullName">Tgl Lahir
                      </label>
                      <d-datepicker v-model.trim="dob"></d-datepicker>
                      <div  class="verror" v-if="!loading && !$v.dob.required">Harap isi kolom ini</div>
                    </d-col>
                    <d-col md=6>
                      <label for="feNoDob">Tidak ada data Tgl Lahir
                      </label>
                      <d-checkbox v-model="no_dob" toggle />                  
                    </d-col>
                  </d-row>
                </d-col>

              <!-- mobile phone -->
                <d-col md="6" class="form-group">
                  <d-row>
                    <d-col md=6>
                      <label for="femobile_phone">HP</label>
                      <d-form-input type="text" id="mobile_phone" placeholder="Nomor HP" v-model.trim="mobile_phone" />
                    </d-col>
                    <d-col md=6>
                      <label for="feNoHP">Tidak ada data no HP
                      </label>
                      <d-checkbox v-model="no_hp" toggle />                  
                    </d-col>
                  </d-row>
                </d-col>

              </d-form-row>

              <d-form-row>
                <!-- dtype -->
                <d-col md=6 >
                  <label for="feType">Tipe</label>
                  <d-form-select v-model="dtype" :options="dtypes" style="padding-left:1px" />
                  <div  class="verror" v-if="!loading && !$v.dtype.required">Harap isi kolom ini</div>
                </d-col>
                <!-- category -->
                <d-col md="6" :class="{ 'form-group--error' : $v.category.$error }">
                  <label for="feICategory">Kategori</label>
                  <d-form-select v-model="category" :options="dcategories" style="padding-left:1px" />
                  <div  class="verror" v-if="!loading && !$v.category.required">Harap isi kolom ini</div>
                </d-col>
                <!-- gky -->
                <d-col md="6">
                  <label for="feGky">Gereja / Yayasan</label>
                  <d-form-select v-model="gky" :options="gkys" style="padding-left:1px" />
                </d-col>
                <!-- location -->
                <d-col md="6">
                  <label for="feLocation">Lokasi</label>
                  <d-form-select v-model="location" :options="locations" style="padding-left:1px" />
                </d-col>
                <!-- is regular  -->
                <d-col md="6" :class="{ 'form-group--error' : $v.is_regular.$error }">
                  <label for="feIsRegular">Donatur Rutin</label>
                  <d-form-select v-model="is_regular" :options="frequencies" style="padding-left:1px" />
                  <div  class="verror" v-if="!loading && !$v.is_regular.required">Harap isi kolom ini</div>
                </d-col>
                <!-- donation_amount -->
                <d-col md="6" class="form-group">
                  <label for="feDonationAmount">Nilai Donasi</label>
                  <!--d-form-input type="text" id="donation_amount" placeholder="nilai donasi" v-model="donation_amount" v-on:blur="frmt(1)" v-on:focus="frmt(0)" /-->
                  <input id="donation_amount" type="text" placeholder="nilai donasi" class="form-control" v-model="donation_amount" @blur="frmt(1)" @focus="frmt(0)">
                </d-col>
                <!-- email -->
                <d-col md="6" class="form-group">
                  <label for="feEmail">Email</label>
                  <d-form-input type="text" id="email" placeholder="alamat email" v-model.trim="email" />
                </d-col>
                <!-- inviter -->
                <d-col md="6" class="form-group">
                  <label for="feInviter">Nama Pengajak (Pengurus Yayasan/STTAA)</label>
                  <d-form-input type="text" id="inviter" placeholder="Nama pengajak (Pengurus Yayasan/STTAA)" v-model.trim="inviter" />
                </d-col>
                <!-- id_card -->
                <d-col md="6" class="form-group">
                  <label for="feIdCard">ID CARD</label>
                  <d-form-input type="text" id="id_card" placeholder="No Identitas" v-model.trim="id_card" />
                </d-col>
                <!-- total_student -->
                <d-col md="6" class="form-group">
                  <label for="feTotalStudent">Jumlah Mahasiswa (Tertanggung)</label>
                  <d-form-input type="text" id="total_student" placeholder="Jumlah Mahasiswa (Tertanggung)" v-model.trim="total_student" />
                </d-col>
              </d-form-row>

              <!-- Address -->
              <d-form-row>
                <d-col md="12" class="form-group">
                <label for="feInputAddress">Alamat</label>
                <textarea 
                    class="form-control w-100"
                    v-model.trim="address"
                    placeholder="Alamat"
                    rows="3"
                    max-rows="6">{{ address }}
                </textarea>
               </d-col>
              </d-form-row>

              <!-- Memo -->
              <d-form-row>
                <d-col md="12" class="form-group">
                <label for="feInputMemo">Memo</label>
                <textarea 
                    class="form-control w-100"
                    v-model.trim="memo"
                    placeholder="Memo"
                    rows="3"
                    max-rows="6">{{ memo }}
                </textarea>
               </d-col>
              </d-form-row>

            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
      </d-col>
 </d-row>
</template>
<style>
.item {
  display: flex;
  align-items: center;
}

.item-name {
  font-size: 12px;
}
</style>
<script>
import VueElementLoading from 'vue-element-loading';
import env from '../../env.vue';
import { required } from 'vuelidate/lib/validators';

export default {
  components: {
    VueElementLoading,
  },
  name: 'donor-info',
  data(){
    return {
      form:'',
      id:'',
      dob:'',
      old_dob:'',
      old_hp:'',
      no_dob:false,
      no_hp:false,
      last_donation_date:'',
      donation_amount:0,
      memo:'',
      is_regular:0,
      frequencies:[
       { value: -1, text:'Tidak' },
       { value: 0, text:'Ya' },
       { value: 1, text:'per 1 Bulan' },
       { value: 3, text:'per 3 Bulan' },
       { value: 6, text:'per 6 Bulan' },
       { value: 12, text:'per 12 Bulan' },
      ],
      fullname:'',
      gky:'',
      gkys:[],
      location:'',
      locations:[],
      gender:'',
      genders:env.genders,
      category:1,
      categories: env.categories,
      dcategories:[],
      dtype:1,
      dtypes:env.dtypes,
      email:'',
      address:'',
      mobile_phone:'',
      inviter:'',
      id_card:'',
      total_student:'',
      created_at:'',
      loading:false,
      timeoutId: null,
      old_data:[],
      error_msg:'',
      show_alert:false,
    }
  },
  validations:{
    fullname:{ required },
    gender:{ required },
    dob:{ required },
    category:{ required },
    is_regular:{ required },
    dtype:{ required },
  },
  watch: {
    '$route.query.id'(newId,oldId){
      if (newId!=oldId){
        if ( newId==0 ) this.resetForm();
      }
    },
    dtype( val ){
       this.filter_cats(val); 
    },
    no_dob( val ){
       if ( val ) {
          this.old_dob=this.dob;
          this.dob='1900-01-01';
       } else {
          if (this.old_dob=='1900-01-01'){
             let dt = new Date();
             this.old_dob=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
           }
          this.dob=this.old_dob;
       }
    },
    no_hp( val ){
       if ( val ) {
          this.old_hp=this.mobile_phone;
          if(this.old_hp=='0000000') this.old_hp='';
          this.mobile_phone='0000000';
       } else {
          this.mobile_phone=this.old_hp;
          this.old_hp='';
       }
    }
  },
  methods: {

    frmt(m){
        if (m==1) this.donation_amount=new Intl.NumberFormat().format(this.donation_amount);
        else
            this.donation_amount=this.donation_amount.toString().replace(/\.|\,/g,'')*1;
    },

    save_form(){
        let dthis=this;        
        let submit=false;
        Object.keys(this.old_data).forEach( key=>{
          if ( JSON.stringify(eval('dthis.'+key))!==JSON.stringify(eval('dthis.old_data.'+key)) ){
            submit=true;
          }
        });
        if(this.fullname==''){
            alert('Harap isi nama lengkap');
            return;
        }
        if(this.dob==''){
            alert('Harap isi tgl lahir');
            return;
        }
        if(this.gender==''){
            alert('Harap isi gender');
            return;
        }
        if (submit){
          this.loading=true;          
          let d = new Date(this.dob);
          let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
          let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d)
          let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)          
          let ddate = `${ye}-${mo}-${da}`;
          let arr={};
          if (this.id==0)this.created_at='2023-10-10T10:10:00.000000Z';
          this.frmt(0);
          arr={
            fullname:this.fullname,
            address:this.address,
            gender:parseInt(this.gender),
            mobile_phone:this.mobile_phone,
            dob:ddate,
            created_at:this.created_at,
            category:this.category,
            donation_amount:parseInt(this.donation_amount),
            is_regular:parseInt(this.is_regular),
            email:this.email,
            created_by:0,
            location_id: parseInt(this.location) > 0 ? parseInt(this.location) :0 ,
            church_id: parseInt(this.gky) > 0 ? parseInt(this.gky) :0 ,
            inviter: this.inviter,
            id_card: this.id_card,
            total_student: parseInt(this.total_student)>0 ? parseInt(this.total_student) : 0,
            memo: this.memo,
          };
          this.axios.post( env.server+'/donator/save/'+this.id, arr
          ).then( resp=>{
            resp=JSON.parse(resp.data);
            this.frmt(1);
            this.loading=false;
            if (resp.message=='donatur duplikat'){
              this.pop_alert('Donatur dengan nama dan nomor HP yg diisi sudah ada');
              return;
            }
            if (this.id==0)this.id=resp.data[0];
            this.$buefy.toast.open({ message:'Data berhasil disimpan',
              position: 'is-bottom',
              type: 'is-success',
            });
          }).catch(e=>{
            this.pop_alert(JSON.parse(e.response.data));
            this.loading=false;
          })
        }
    },
    pop_alert(msg){
      if (msg==undefined) return;
      this.$refs.dalert.dismissed=false;
      this.show_alert=5;
      this.error_msg=msg;
    },
    resetForm(){
      var dthis=this;
      this.old_data={ 
      id:'',
      fullname:'',
      dob:'',
      gender:{value:'1',text:'Pria'},
      category:1,
      address:'',
      mobile_phone:'',
      created_at:'',
      email:'',
      gky:{value:'0',text:''},
      location:{value:'0',text:''},
      inviter:'',
      id_card:'',
      total_student:'',
      memo:'',
      }
      Object.keys(this.old_data).forEach( key=>{
        if (key!='gender')
          eval('dthis.'+key+'=\'\'');
      });        
    },
    loadForm(){
      this.loading=true;
      if ( this.locations==[] || this.organizations==[] ){
        setTimeout(()=>{this.loadForm();},500);
        return;
      }
      this.axios.get( env.server+'/donator/load/'+this.id).then(
        resp=>{
          resp.data = JSON.parse(resp.data);
          resp.data = resp.data.data;
          this.fullname=resp.data.fullname;
          this.dob=resp.data.dob;
          this.mobile_phone=resp.data.mobile_phone;
          this.address=resp.data.address;
          this.gender=''+resp.data.gender;
          this.loading=false;
          this.old_data=resp.data,
          this.created_at=resp.data.created_at,
          this.email=resp.data.email;
          this.last_donation_date=resp.data.last_donation_date;
          this.is_regular=resp.data.is_regular;
          this.donation_amount=resp.data.donation_amount;
          this.frmt(1);
          let dtype = this.categories.filter( (a)=>{ if (a.value==resp.data.category) return a });
          this.dtype=dtype[0].dtype;
          let dlocation = this.locations.filter( (a)=>{ if (a.value==resp.data.location_id) return a });
          this.location=dlocation[0].value;
          let dgky = this.gkys.filter( (a)=>{ if (a.value==resp.data.church_id) return a });
          this.gky=dgky[0].value;
          this.inviter=resp.data.inviter;
          this.id_card=resp.data.id_card;
          this.total_student=parseInt(resp.data.total_student)>0 ? resp.data.total_student:'';
          this.memo=resp.data.memo;
          
          this.filter_cats();
          setTimeout( ()=>{ this.category=resp.data.category }, 100 );
          if (this.dob=='1900-01-01')this.no_dob=true;
          if (this.mobile_phone=='0000000'){this.no_hp=true;this.old_hp='';}
        }
      );
    },
    filter_cats(){
      this.dcategories = this.categories.filter( (a)=>{ if (a.dtype==this.dtype) return a; else return false });
    }
  },
  mounted(){
    this.id=this.$route.query.id;
    this.axios.get( env.server+'/church/all').then( resp=>{
        resp.data = JSON.parse(resp.data);
        let arr=[{text:'',value:0}];
        for(let i=0;i<resp.data.data.length;i++){
           arr.push( { text: resp.data.data[i].name , value: resp.data.data[i].id });
        }
        this.gkys=arr;
    });
    this.axios.get( env.server+'/location/all').then( resp=>{
        resp.data = JSON.parse(resp.data);
        let arr=[{text:'',value:0}];
        for(let i=0;i<resp.data.data.length;i++){
           arr.push( { text: resp.data.data[i].name , value: resp.data.data[i].id });
        }
        this.locations=arr;
    });
    if ( this.id>0 ){
        setTimeout(()=>{this.loadForm();},100);
    } else {
      this.resetForm()
      this.category=1;
      let arr=this.$store.state.list;
      var dt = new Date();
      this.dob=dt.getFullYear()+'-'+(dt.getMonth()+1)+'-'+dt.getDate();
      this.filter_cats(); 
    }
  },
};
</script>
